import { render, staticRenderFns } from "./Cosechadoras.vue?vue&type=template&id=69e76d34&"
import script from "./Cosechadoras.vue?vue&type=script&lang=ts&"
export * from "./Cosechadoras.vue?vue&type=script&lang=ts&"
import style0 from "./Cosechadoras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('69e76d34', component.options)
    } else {
      api.reload('69e76d34', component.options)
    }
    module.hot.accept("./Cosechadoras.vue?vue&type=template&id=69e76d34&", function () {
      api.rerender('69e76d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Sugal/Cosechadoras.vue"
export default component.exports